import { propsBasicLayoutType } from 'utils/proptypes';

const NoneLayout = (props: propsBasicLayoutType) => {
   return props.children;
};

export default NoneLayout;
